/**
 * Sophia Platform (Cloudflare Edge-Native Edition)
 *
 * @file        Lowlight Syntax Highlighting Configuration (Task 10.2.1)
 * @author      Le Viet Quang <quangle@fourelementscorp.com>
 * @copyright   (c) 2026 Le Viet Quang / Four Elements Corp
 * @license     MIT
 */

import { common, createLowlight } from 'lowlight';

export const lowlight = createLowlight(common);
